/* eslint-disable */
const namespace = 'secrrtmangement';
const GETTABLELIST = `${namespace}gettablelist`; // 获取table数据
const DEL = `${namespace}del`; // 获取table数据
const UPDATA = `${namespace}updata`; // 获取table数据
const GETSYSTEMANAGMENT = `${namespace}getSystem`; // 获取table数据
export { GETTABLELIST, DEL, UPDATA, GETSYSTEMANAGMENT };
